export const EditIcon = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Icon / Edit">
			<path
				id="Vector"
				d="M18.9832 6.45333C19.0682 6.36853 19.1356 6.2678 19.1816 6.15691C19.2276 6.04601 19.2513 5.92714 19.2513 5.80708C19.2513 5.68703 19.2276 5.56815 19.1816 5.45726C19.1356 5.34637 19.0682 5.24564 18.9832 5.16083L16.8382 3.01583C16.6549 2.8325 16.4257 2.75 16.1873 2.75C15.949 2.75 15.7198 2.84167 15.5457 3.01583L13.6308 4.9307L17.0683 8.3682L18.9832 6.45333Z"
				fill="#636172"
			/>
			<path
				id="Vector_2"
				d="M3.74902 18.2501V16.2269L12.8874 7.08853L14.9106 9.11182L5.77231 18.2501H3.74902Z"
				stroke="#636172"
				strokeWidth="2"
			/>
		</g>
	</svg>
);
